import { render, staticRenderFns } from "./motivosProspecto.vue?vue&type=template&id=001978c5"
import script from "./motivosProspecto.vue?vue&type=script&lang=js"
export * from "./motivosProspecto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports